import {
  configureStore,
  ThunkAction,
  Action,
  Reducer,
  AnyAction,
} from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/dist/query"

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist"
import storage from "redux-persist/lib/storage"
import { baseApi } from "../../shared/api"
import { IThemeState, themeReducer } from "../../entities/theme/model/theme"
import {
  IUsersState,
  invalidateAccessTokenListener,
  userReducer,
} from "../../entities/user/model/user"

import {
  IPagination,
  InterviewsPaginationReducer,
} from "../../entities/hiring/ui/tableComponents/tablePagination/model/pagination"
import {
  IWeekPagination,
  weekPaginationReducer,
} from "../../entities/hiring/ui/tableComponents/tablePagination/model/weekPagination"
import {
  ISelectedTimeSlot,
  selectedTimeSlotReducer,
} from "../../entities/hiring/ui/create/dialogs/model/SelectedTimeSlot"
import {
  IInterviewDate,
  IInterviewFullRow,
  IInterviewGroup,
  IInterviewMode,
  interviewDateReducer,
  interviewGroupReducer,
  interviewModeReducer,
  interviewRowReducer,
} from "../../entities/hiring/ui/create/dialogs/model/Interviews"
import { interwieverReducer } from "../../entities/hiring/ui/create/dialogs/model/Interviewers"
import { IInterviewer } from "../../entities/hiring/model/create/CreateInterwiewer"
import { avalaibleScheduleReducer, IAvailableScheduleCandidatesArray } from "../../entities/hiring/ui/create/dialogs/model/AvalaibleScheduleCandidates"

const userConfig = {
  key: "user",
  storage,
}

const themeConfig = {
  key: "theme",
  storage,
}

const store = configureStore({
  reducer: {
    user: persistReducer(userConfig, userReducer) as unknown as Reducer<
      IUsersState,
      AnyAction
    >,
    theme: persistReducer(themeConfig, themeReducer) as unknown as Reducer<
      IThemeState,
      AnyAction
    >,
    pagination: InterviewsPaginationReducer as unknown as Reducer<
      IPagination,
      AnyAction
    >,
    weekPagination: weekPaginationReducer as unknown as Reducer<
      IWeekPagination,
      AnyAction
    >,
    selectedTimeSlot: selectedTimeSlotReducer as unknown as Reducer<
      ISelectedTimeSlot,
      AnyAction
    >,
    interviewGroup: interviewGroupReducer as unknown as Reducer<
      IInterviewGroup,
      AnyAction
    >,
    interviewRow: interviewRowReducer as unknown as Reducer<
      IInterviewFullRow,
      AnyAction
    >,
    interviewMode: interviewModeReducer as unknown as Reducer<
      IInterviewMode,
      AnyAction
    >,
    interviewDate: interviewDateReducer as unknown as Reducer<
      IInterviewDate,
      AnyAction
    >,

    Interviewers: interwieverReducer as unknown as Reducer<
      IInterviewer,
      AnyAction
    >,
    AvailableScheduleCandidates: avalaibleScheduleReducer as unknown as Reducer<
     IAvailableScheduleCandidatesArray,
      AnyAction
    >,

    [baseApi.reducerPath]: baseApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware, invalidateAccessTokenListener.middleware),
})
setupListeners(store.dispatch)
export const persistor = persistStore(store)
export default store

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
